export const nationalities = [
  "Brasileiro",
  "Afegão",
  "Alemão",
  "Americano",
  "Angolano",
  "Árabe",
  "Argélia",
  "Argentino",
  "Armeno",
  "Australiano",
  "Austríaco",
  "Bahamense",
  "Bangladesh",
  "Barbadense",
  "Bechuano",
  "Belga",
  "Belizenho",
  "Boliviano",
  "Britânico",
  "Camaronense",
  "Canadense",
  "Chileno",
  "Chinês",
  "Cingalês",
  "Colombiano",
  "Comorense",
  "Congolês",
  "Costarriquenho",
  "Croata",
  "Cubano",
  "Dinamarquês",
  "Dominicana",
  "Dominicano",
  "Egípcio",
  "Equatoriano",
  "Escocês",
  "Eslovaco",
  "Esloveno",
  "Espanhol",
  "Francês",
  "Galês",
  "Ganés",
  "Granadino",
  "Grego",
  "Guatemalteco",
  "Guianense",
  "Guianês",
  "Haitiano",
  "Holandês",
  "Hondurenho",
  "Húngaro",
  "Iemenita",
  "Indiano",
  "Indonésio",
  "Inglês",
  "Iraniano",
  "Iraquiano",
  "Irlandês",
  "Israelita",
  "Italiano",
  "Jamaicano",
  "Japonês",
  "Líbio",
  "Malaio",
  "Marfinense",
  "Marroquino",
  "Mexicano",
  "Moçambicano",
  "Neozelandês",
  "Nepalês",
  "Nicaraguense",
  "Nigeriano",
  "Norte-coreano",
  "Noruego",
  "Omanense",
  "Palestino",
  "Panamenho",
  "Paquistanês",
  "Paraguaio",
  "Peruano",
  "Polonês",
  "Portorriquenho",
  "Português",
  "Qatarense",
  "Queniano",
  "Romeno",
  "Ruandês",
  "Russo",
  "Salvadorenho",
  "Santa-lucense",
  "São-cristovense",
  "São-vicentino",
  "Saudita",
  "Sérvio",
  "Sírio",
  "Somali",
  "Sueco",
  "Suíço",
  "Sul-africano",
  "Sul-coreano",
  "Surinamês",
  "Tailandês",
  "Timorense",
  "Trindadense",
  "Turco",
  "Ucraniano",
  "Ugandense",
  "Uruguaio",
  "Venezuelano",
  "Vietnamita",
  "Zimbabuense"
]